import { useFiltrosGlobales } from '@/lib/FiltrosGlobalesContext';
import { cliente } from '@/lib/cliente';
import { useQuery } from '@tanstack/react-query';

export function useCostosMensuales() {
  const { filtros } = useFiltrosGlobales();
  return useQuery({
    queryKey: ['costos-mensuales', filtros],
    queryFn: () => cliente.costos.mensuales(filtros),
  });
}
